import { useMemo } from 'react';
import { colors }  from 'utils/colors';
import { store }   from 'index';

const useDDStyle = (
  dropDownItems: string[],
  variant:       string,
  openDropDown:  string,
  manualOn:      boolean,
  manualVal:     string
) => { 

  const state     = store.getState();
  const sizeState = state.size;

  const [selectorStyle, menuStyle, iconContainerStyle, iconStyle, filterStyle] = useMemo(() => {

    const { size, navBarSize, wideScreen } = sizeState;
    
    const open  = openDropDown === variant;
    const width = variant === 'default' ? 250 : 300;

    return [
      {
        height:   navBarSize,
        left:     10,
        position: (variant === 'default' || !wideScreen) ? 'absolute' as 'absolute' : undefined,
      },
      {
        top:       navBarSize,
        height:    !open ? 0 : Math.min((50 * (dropDownItems.length + ( variant === 'links' ? 1 : 0 ))), (size[1] - navBarSize)),
        opacity:   !open ? 0 : 1,
        width:     width,
        left:      ( !wideScreen || variant === 'default' ) ? 0 : undefined,
        transform: ( !wideScreen || variant === 'default' ) ? undefined : `translate(${ width/2 - 30 }px, 0%)`,
      },
      {
        transform:  `translate(${ (wideScreen && variant === 'links') ? 0 : size[0] > 700 ? 25 : -25 }%, 5px)`,
        border:     manualOn && manualVal === "dropDownButton" ? `2px solid ${ colors.blue }` : undefined
      },
      {
        fontSize:   size[0] > 700 ? 52 : 40,
        transform: `rotate(${ open ? -180 : 0 }deg)`,
        transition: 'all 0.3s'
      },
      {
        top:     !open ? '-100vh' : navBarSize,
        height:  !open ? 0 : size[1] - navBarSize,
        width:   !open ? 0 : '100vw',
        opacity: open ? 1 : 0
     }
    ]
  },[ openDropDown, sizeState, dropDownItems, manualOn, manualVal, variant ])

  return { selectorStyle, menuStyle, iconContainerStyle, iconStyle, filterStyle }
}




export default useDDStyle